import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/common/pg_first_ico.png'
import _imports_1 from '@/assets/common/pg_prev_ico.png'
import _imports_2 from '@/assets/common/pg_next_ico.png'
import _imports_3 from '@/assets/common/pg_end_ico.png'


const _hoisted_1 = {
  key: 0,
  class: "total_length"
}
const _hoisted_2 = {
  key: 1,
  class: "gallery_board"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick", "innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "no_list"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "게시글이 없습니다.", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "survey_list"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML", "onClick"]
const _hoisted_11 = {
  key: 3,
  class: "paging_wrap"
}
const _hoisted_12 = {
  class: "dataTables_paginate paging_full_numbers",
  id: "list_paginate"
}
const _hoisted_13 = { class: "pagination" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([$setup.props.type === 'vas' ? 'board_wrap' : '', [$setup.props.customClass]]),
    id: "servey_list"
  }, [
    ($setup.props.isShowTotal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($props.totalLength) + " " + _toDisplayString(_ctx.$t("notice.count")), 1))
      : _createCommentVNode("", true),
    ($setup.props.type !== 'vas')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.list.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (row, idx) => {
                  return (_openBlock(), _createElementBlock("li", { key: idx }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, colIdx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        onClick: ($event: any) => (col.clickable === true ? $setup.onRowClick(row) : ''),
                        innerHTML: $setup.fnRender(row, col),
                        class: _normalizeClass([col.clickable === true ? 'areaClick' : '', col.class])
                      }, null, 10, _hoisted_4))
                    }), 256))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          ($props.list.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.state.type === 'vas')
      ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
          ($setup.props.isShowTitle)
            ? (_openBlock(), _createElementBlock("thead", _hoisted_9, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, idx) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: idx,
                      class: _normalizeClass([col.class])
                    }, _toDisplayString(col.label), 3))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (row, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, colIdx) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: colIdx,
                    innerHTML: $setup.fnRender(row, col),
                    onClick: ($event: any) => (col.clickable === true ? $setup.onRowClick(row) : ''),
                    class: _normalizeClass([col.clickable === true ? 'areaClick' : '', col.class])
                  }, null, 10, _hoisted_10))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.props.isShowPageBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", {
                class: "paginate_button page-item first disabled",
                id: "list_first",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fnPaging(1)))
              }, [
                _createVNode(_component_router_link, {
                  to: "#",
                  "aria-controls": "list",
                  "data-dt-idx": "0",
                  tabindex: "0",
                  class: "page-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", {
                class: "paginate_button page-item previous disabled",
                id: "list_previous",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.currentPage > 1 ? $setup.fnPaging($props.currentPage - 1) : ''))
              }, [
                _createVNode(_component_router_link, {
                  to: "#",
                  "aria-controls": "list",
                  "data-dt-idx": "1",
                  tabindex: "0",
                  class: "page-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              ($props.currentPage <= 3)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Math.min($setup.paging, 5), (index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      onClick: ($event: any) => ($setup.fnPaging(index)),
                      class: _normalizeClass(["paginate_button page-item", [index === $props.currentPage ? 'active' : '']])
                    }, _toDisplayString(index), 11, _hoisted_16))
                  }), 128))
                : ($props.currentPage >= $setup.paging - 2)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([$setup.paging - 4, $setup.paging - 3, $setup.paging - 2, $setup.paging - 1, $setup.paging], (index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        onClick: ($event: any) => ($setup.fnPaging(index)),
                        class: _normalizeClass(["paginate_button page-item", [index === $props.currentPage ? 'active' : '']])
                      }, _toDisplayString(index), 11, _hoisted_17))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList([-2, -1, 0, 1, 2], (offset) => {
                      return _createElementVNode("li", {
                        key: $props.currentPage + offset,
                        onClick: ($event: any) => ($setup.fnPaging($props.currentPage + offset)),
                        class: _normalizeClass(["paginate_button page-item", [$props.currentPage + offset === $props.currentPage ? 'active' : '']])
                      }, _toDisplayString($props.currentPage + offset), 11, _hoisted_18)
                    }), 64)),
              _createElementVNode("li", {
                class: "paginate_button page-item next",
                id: "list_next",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($props.currentPage < $setup.paging ? $setup.fnPaging($props.currentPage + 1) : ''))
              }, [
                _createVNode(_component_router_link, {
                  to: "#",
                  "aria-controls": "list",
                  "data-dt-idx": "4",
                  tabindex: "0",
                  class: "page-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", {
                class: "paginate_button page-item last",
                id: "list_last",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.fnPaging($setup.paging)))
              }, [
                _createVNode(_component_router_link, {
                  to: "#",
                  "aria-controls": "list",
                  "data-dt-idx": "5",
                  tabindex: "0",
                  class: "page-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}